<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn
        class="action-btn-doc"
        fab
        small
        icon
        :style="color ? `background-color: ${color} !important` : ''"
        @click="downloadDocument(currentDocument)"
        v-on="on"
      >
        <AppIcon src="/invoices/download.svg" :size="24" :preserveColors="true"/>
      </v-btn>
    </template>
    <span>Descargar documento</span>
  </v-tooltip>
</template>

<script>
import { DocumentDownloadService } from "@/modules/document/services/DocumentDownloadService";

export default {
  name: "DocumentDownload",
  props: {
    currentDocument: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      downloadService: new DocumentDownloadService(),
    };
  },
  methods: {
    downloadDocument(currentDocument) {

      const downloadPayload = this.downloadService.prepareDownload(currentDocument);

      this.$store.dispatch(
        "documents/downloadFile", 
        downloadPayload
      );
    },
  },
};
</script>
